import React from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { AuthContext } from '../../authContext';
import useTokenStorage from '../useTokenStorage';
export const useLogout = ({ onLogout } = {}) => {
    const { forgetAuthToken } = useTokenStorage();
    const { setIdentity, setToken } = React.useContext(AuthContext);
    const logout = useCallbackRef(() => {
        forgetAuthToken();
        setToken(null);
        setIdentity((prevState) => ({
            ...prevState,
            user: undefined,
        }));
        onLogout?.();
    });
    return logout;
};
